export interface OwnersFilterType {
  selectedOwners: server.dto.UserSmall[]
}

export const getSortedOwnerLabels = (filter: OwnersFilterType) => {
  return filter.selectedOwners.map(b => b.fullName)
    .sort((a, b) => a.localeCompare(b));
};

export const initialOwnersFilter: OwnersFilterType = {
  selectedOwners: []
};